import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getDataCategories = (params) => ({
  type: actionTypes.GET_DATA_CATEGORIES,
  params
});

export const createDataCategory = (payload) => ({
  type: actionTypes.CREATE_DATA_CATEGORY,
  payload
});

export const updateDataCategory = (payload) => ({
  type: actionTypes.UPDATE_DATA_CATEGORY,
  payload
});

export const updateDataCategoryStatus = (Id) => ({
  type: actionTypes.UPDATE_DATA_CATEGORY_STATUS,
  Id
});

export const deleteDataCategory = (Id) => ({
  type: actionTypes.DELETE_DATA_CATEGORY,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});
